/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoTariffaMensaDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetTariffaMensaCittadinoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}


export interface TariffaMensaCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Tariffa mensa del figlio, con i motivi e il tariffario del servizio.
     * Audience CITTADINO. Ritorna lo stato, il riepilogo (costo a pasto e motivi come codici e parametri) e il tariffario per ordine di scuola e fascia ISEE, con la cella applicata al figlio. Le regole che non hanno forma di tabella sono negli altri casi. Figlio non proprio o domanda non accettata → 404 privacy-preserving.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti/{id_studente}/tariffa
* @param requestParameters
     */
    getTariffaMensaCittadino(requestParameters: GetTariffaMensaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<CittadinoTariffaMensaDTO>;

}
